import axios from "axios";

const api = axios.create({
  // Use the root domain for the base URL.
  // This is crucial for the /sanctum/csrf-cookie call to work correctly.
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000",
  withCredentials: true, // Send cookies with every request
  headers: {
    
    "X-Requested-With": "XMLHttpRequest",
    Accept: "application/json",
    // Add the API key to all requests
    "X-API-KEY": process.env.REACT_APP_PUBLIC_API_KEY,
  },
});
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
export default api;
